import {Grid} from "../../core/components/grid";
import {Helper} from "../../core/util/helper";
import {Dialog, DialogProps} from "../../core/components/dialog";
import {ToolBar} from "../../core/components/toolBar";
import {Config} from "../../core/config/config";
import {MultiSelect} from "../../core/components/multiSelect";
import {DropDownList} from "../../core/components/dropDownList";
import {FieldInstance} from "../../core/components/field";
import {HTTPService, JsonResultClass} from "../../core/util/httpManager";
import {ComponentHelper} from "../../core/util/componentHelper";
import {SheetEventType} from "../../../siteManagement/sheet";
import {General} from "../../../siteManagement/general";
import { BaseComponentProps, BaseField } from "../../core/components/baseComponentProps";
import React from "react"
interface CategoryPermission {
    EntityId: string;
    EntityLabel: string;
    Permission: Permission;
    Writable?: boolean;
    Id: string;
}

enum Permission {
    None = 0,
    CanRead = 1,
    CanWrite = 2
}

// noinspection JSUnusedGlobalSymbols
export default class EditDokukatPermissions extends React.Component<EditDokukatPermissionsProps, EditDokukatPermissionsState>{
    private gridOptions: kendo.ui.GridOptions;
    private permissions = [
        {
            name: Helper.getTranslation("Adresse.Gesperrt"),
            value: Permission.None
        },
        {
            name: Helper.getTranslation("Standard.Leserecht"),
            value: Permission.CanRead
        },
        {
            name: Helper.getTranslation("Standard.Schreibrecht"),
            value: Permission.CanWrite
        }
    ]
    private dialogRef: DokukatPermissionDialog;
    constructor(props: EditDokukatPermissionsProps) {
        super(props)
        this.state = {
            values: props.value.filter(this.distinct).sort(this.orderByAlphabet),
            selected: null
        }
        this.initApp();
    }
    
    private initApp = () => {
        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, eventInfo => {
            if (eventInfo != null && eventInfo.event == "ReloadRights")
            {
                this.setState({
                    values: this.props.value.filter(this.distinct).sort(this.orderByAlphabet),
                });
            }
        });
        
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "EntityLabel",
                    title: this.props.field.label
                },
                {
                    field: "Permission",
                    title: Helper.getTranslation("Standard.Permission"),
                    template: () => {
                        return '<div id="dokuKatDropDownWrapper"><input class="dropDownTemplate"/></div>';
                    }
                }
            ]

        };
    }

    private updateValues = (values: CategoryPermission[]) => {
        this.setState({ values: values.filter(this.distinct).sort(this.orderByAlphabet) }, () => {
            this.props.onChange(this.props.field, values)
        })
    }

    //für array.sort
    private orderByAlphabet = (a: CategoryPermission, b: CategoryPermission) => {
        if (a.EntityLabel < b.EntityLabel) {
            return -1;
        }
        if (a.EntityLabel > b.EntityLabel) {
            return 1;
        }
        return 0;
    }

    //für array.filter
    private distinct = (value: CategoryPermission, index: number, self: CategoryPermission[]) => {
        return self.findIndex(f => f.EntityLabel.toLowerCase() === value.EntityLabel.toLowerCase()) === index;
    };

    private renderGrid = () => {
        return (
            <div className="flex-container" id={this.props.field.model}>
                <Grid
                    data={this.state.values}
                    options={this.gridOptions}
                    id="staticEmails"
                    onDataBound={this.onDataBound}
                    onSelectionChanged={this.onSelectionChange}
                    selectFilter={Helper.hasValue(this.state.selected) ? this.state.selected.EntityLabel : null}
                />
            </div>
        );
    }

    private onSelectionChange = (item: CategoryPermission) => {
        if (Helper.hasValue(item)) {
            this.setState({ selected: item })
        }
    }

    private onDataBound = (e) => {
        const grid = e.sender;
        const items = e.sender.items();

        let data = e.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            if (!data[i].Writable)
            {
                let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                let cell = $("td", row);
                cell.css("background-color", "#e0f7fa");
                cell.css("color", "#333");
            }
            // if (data[i].PIndex != null) {
            //     let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
            //     let cell = $("td", row);
            //     cell.css("background-color", "#e0f7fa");
            //     cell.css("color", "#333");
            // }
        }

        const dataSource = this.permissions;
        const onValueChange = (p: Permission) => {
            const data = this.state.values;
            const index = data.findIndex(f => f.EntityId === this.state.selected.EntityId);
            data[index].Permission = p;
            this.updateValues(data);
        }

        items.each(function () {
            const dataItem = grid.dataItem(this);
            const ddt = $(this).find('.dropDownTemplate');
            $(ddt).kendoDropDownList({
                value: dataItem.Permission.toString(),
                dataSource: dataSource,
                dataTextField: "name",
                dataValueField: "value",
                enable: dataItem.Writable,
                change: (e) => {
                    const selectedIndex = e.sender["selectedIndex"];
                    onValueChange(dataSource[selectedIndex].value);
                }
            });
        });
        this.fixGridStyle();
    }


    private fixGridStyle = () => {
        const spans = document.querySelectorAll("#dokuKatDropDownWrapper > span") as NodeListOf<HTMLSpanElement>;
        spans.forEach((el) => {
            el.style.width = "100%"
        });
    }

    private renderReplacementText = () => {
        return (
            <div style={{ display: "grid" }}>
                <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1" }}>
                    <i className="fal fa-low-vision fa-10x" style={{ opacity: 0.1 }} />
                </div>
                <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "40px" }}>
                    <label style={{ fontSize: "15px" }}>
                        {this.props.field.replacementLabel}
                    </label>
                </div>
            </div>
        );
    }


    private createToolBar = () => {
        let customButtons = [
            { caption: Config.translations.add, enabled: true, iconClass: "k-i-plus", id: "add" },
            { caption: Config.translations.delete, enabled: Helper.hasValue(this.state.selected) && this.state.selected.Writable, iconClass: "k-i-close", id: "remove" }
        ];
        return (
            <>
                <ToolBar customButtons={customButtons} handleCustomButtonClick={this.handleClickCustomButton} />
            </>
        );
    }

    private handleClickCustomButton = (id: string) => {
        switch (id) {
            case "add":
                this.dialogRef.openDialog();
                break;
            case "remove":
                const data = this.state.values.filter(f => f.Id !== this.state.selected.Id)
                this.updateValues(data)
                break;
        }
    }

    private renderDialog = () => {
        return <>
            <DokukatPermissionDialog
                dataSourceUrl={this.props.field.dataSourceUrl}
                permissions={this.permissions}
                label={this.props.field.label}
                ref={(ref) => { this.dialogRef = ref }}
                onOk={this.onOK}
            />
        </>;
    }

    private onOK = (permissions: CategoryPermission[]) => {
        const data: CategoryPermission[] = this.state.values
        permissions.forEach((p) => {
            const index = data.findIndex(f => f.EntityId.toUpperCase() === p.EntityId.toUpperCase());
            if (index === -1) {
                data.push(p);
            } else {
                data[index].Permission = p.Permission;
            }
        })
        this.updateValues(data);
    }

    render() {
        const toolBar = this.createToolBar();
        const inner = Helper.hasValue(this.gridOptions) && this.state.values.length > 0 ? this.renderGrid() : this.renderReplacementText();
        const dialog = this.renderDialog();
        return (
            <>
                {toolBar}
                {inner}
                {dialog}
            </>
        );
    }
}

interface EditDokukatPermissionsProps extends BaseComponentProps{
    value: CategoryPermission[];
    onChange: (field: { model: string }, value: CategoryPermission[]) => void;
    field: EditDokukatPermissionsField;
}

interface EditDokukatPermissionsField extends BaseField {
    dataSourceUrl: string;
    label: string;
    replacementLabel: string;
}

interface EditDokukatPermissionsState {
    values: CategoryPermission[];
    selected: CategoryPermission;
}

interface KeyValueAndRole{
    Key: string;
    Value: string;
    IsUser: boolean;
    Role: string;
}

class DokukatPermissionDialog extends React.Component<DokukatPermissionDialogProps, DokukatPermissionDialogState>{
    private factory = ComponentHelper.createFactory();
    public dataSource: KeyValueAndRole[] = [];
    private dialogProps: DialogProps = {
        title: "",
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.setState({ dialogOpen: false })

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.setState({ dialogOpen: false }, () => {
                        const permissions: CategoryPermission[] = this.state.values.map((item) => {
                            return {
                                EntityId: item.Key,
                                EntityLabel: item.Value,
                                Writable: true,
                                Id: kendo.guid(),
                                Permission: this.state.permission
                            }
                        })
                        this.props.onOk(permissions)
                    })
                },
                primary: true
            }
        ],
        width: 500
    };
    constructor(props) {
        super(props)
        this.state = {
            dialogOpen: false,
            values: [],
            permission: Permission.None
        }
        this.initApp();
    }

    private initApp = async () => {
        const result = await HTTPService.get<JsonResultClass>(this.props.dataSourceUrl)
        if (Helper.hasValue(result) && result.Code == 0) {
            this.dataSource = result.Data;
        }
        this.setState({})
    }

    openDialog = () => {
        this.setState({ dialogOpen: true, values: [] })
    }

    private createDialog = () => {
        return (
            <>
                <Dialog {...this.dialogProps} open={this.state.dialogOpen}>
                    {this.renderDataMultiselect()}
                    {this.renderPermissionDropDown()}
                </Dialog>
            </>
        );
    }

    private renderDataMultiselect = () => {
        const props = this.factory.getDefaultMultiSelectProps();
        props.dataSource = this.dataSource;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.value = this.state.values;
        props.onChange = (_, value) => {
            this.setState({ values: value })
        }

        return (
            <FieldInstance label={this.props.label} noHover={true}>
                <MultiSelect {...props} />
            </FieldInstance>
        );
    }

    private renderPermissionDropDown = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.props.permissions;
        props.field.optionLabel = "";
        props.field.dataTextField = "name";
        props.field.dataValueField = "value";
        props.value = this.state.permission;
        props.onChange = (_, value) => {
            this.setState({permission: value})
        }

        return (
            <FieldInstance label={Helper.getTranslation("Standard.Permission")} noHover={true}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    render() {
        return this.state.dialogOpen ? this.createDialog() : null;
    }
}

interface DokukatPermissionDialogProps {
    dataSourceUrl: string;
    label: string;
    permissions: any[];
    onOk: (permissions: CategoryPermission[]) => void;
}

interface DokukatPermissionDialogState {
    dialogOpen: boolean;
    values: KeyValueAndRole[];
    permission: Permission;
}